module.exports = __webpack_public_path__ + "img/icn_first.8cf86832.svg";